import { useEffect } from 'react';
import * as FullStory from '@fullstory/browser';
import { useAccount } from '~/accountContext';

export const useFullStory = () => {
  const { account } = useAccount();

  // Should we identify based on accountId, orgId, or userId.
  const accountId = account?.id;
  // const organizationId = account?.currentOrganization?.id;
  const planId = account?.currentOrganization?.billing?.subscription?.plan?.id;
  const isPaying = !!planId && planId !== 'free';

  const isProduction = process.env.NODE_ENV === 'production';

  // we need this info early to decide if we should load Fullstory or not
  const shouldLoadFullstory = !!accountId && !!isProduction && !!isPaying;

  useEffect(() => {
    if (shouldLoadFullstory) {
      FullStory.init({
        orgId: '9F6GW',
      });
    }
  }, [shouldLoadFullstory, planId, accountId]);
};
